import { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Clear any lingering localStorage tokens
    localStorage.removeItem("folio-user");
    localStorage.removeItem("folio-token");
    
    const raw = sessionStorage.getItem("folio-user");
    return raw ? JSON.parse(raw) : null;
  });

  const [token, setToken] = useState(() => {
    return sessionStorage.getItem("folio-token") || null;
  });

  const login = (userData, userToken) => {
    setUser(userData);
    setToken(userToken);
    sessionStorage.setItem("folio-user", JSON.stringify(userData));
    sessionStorage.setItem("folio-token", userToken);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("folio-user");
    localStorage.removeItem("folio-token");
    sessionStorage.removeItem("folio-user");
    sessionStorage.removeItem("folio-token");
  };

  return (
    <AuthContext.Provider
      value={{ user, token, isAuthenticated: !!user, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
